module.exports = __webpack_public_path__ + "img/dashboard-icon.b1c43b02.svg";